import {Card, CardContent, makeStyles} from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import {QuoteFormControlElement} from './QuoteFormControlElement';

type CheckboxCardProps = {
  selected: boolean;
  onChange: (event?: React.ChangeEvent<HTMLInputElement>) => void;
  label: string | React.ReactNode;
  className?: string;
  disabled?: boolean;
};

const useCheckboxCardStyles = makeStyles(() => ({
  checkboxCard: (props: CheckboxCardProps) => ({
    cursor: 'pointer',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    marginTop: '20px',
    padding: '2rem 1rem',
    border: props.selected ? '1px solid #13B7DB' : '1px solid #D8D8D8',
    height: '80%',
  }),
}));

export const CheckboxCard = (props: CheckboxCardProps) => {
  const {label, selected, onChange, className} = props;
  const classes = useCheckboxCardStyles(props);

  return (
    <Card className={classNames(classes.checkboxCard, className)} onClick={() => onChange()}>
      <CardContent>
        <QuoteFormControlElement
          controlType="checkbox"
          label={label}
          checked={selected}
          onChange={onChange}
          disabled={props.disabled}
        />
      </CardContent>
    </Card>
  );
};
